@use '../../ui-library/styles/surface.scss' as surface;
@use '../../ui-library/styles/text.scss' as text;
@use '../../ui-library/styles/typography.scss' as typography;
@use '../../ui-library/styles/layout.scss' as layout;

$parts-height: 28px;

.header {
  padding: 0 12px;
  display: flex;
  align-items: end;
  justify-content: space-between;
  height: layout.$header-height;

  .headerLogo {
    padding-left: 8px;
    display: flex;
    flex-shrink: 0;
  }

  .headerNavPart {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1;
    min-width: 0;
    height: $parts-height;

    .headerNavItems {
      display: flex;
      align-items: center;
      min-width: 0;
      gap: 8px;
    }
  }

  .headerButtons {
    display: flex;
    align-items: center;
    gap: 2px;
    height: $parts-height;
  }

  .headerIconButton {
    &:hover:not(:disabled) {
      background-color: surface.$surface-hover !important;
    }

    &:active:not(:disabled) {
      background-color: surface.$surface-active !important;
    }
  }

  .headerAvatar {
    all: unset;
    @include typography.text-s-medium;
    font-size: 11px;
    user-select: none;
    cursor: pointer;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    margin-left: 6px;
    border-radius: 999px;
    background-color: surface.$surface-active;
    color: text.$text-secondary;
  }
}
